import React, {HTMLAttributes, useContext} from 'react';
import {FocusStrategy} from '@react-types/shared';

export interface MenuContextValue extends HTMLAttributes<HTMLElement> {
  onClose?: () => void;
  closeOnSelect?: boolean;
  shouldFocusWrap?: boolean;
  autoFocus?: boolean | FocusStrategy;
}

export const MenuContext = React.createContext<MenuContextValue>(null!);

export function useMenuContext(): MenuContextValue {
  return useContext(MenuContext);
}
